import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './dashboard.module.scss';
import DashboardHeader from './DashboardHeader';
import DashboardTabs from './DashboardTabs';
import { DASHBOARD_TABS } from './constants';
import OverviewContent from './DashboardOverview/OverviewContent';
import PendingContent from './DashboardPendings/PendingContent';
import PerformanceContent from './DashboardPerformance/PerformanceContent';
import DashboardFilters from './DashboardFilters';
import {
  removeTag,
  setSelectedIds,
} from '@/store/slices/components/filterBar/FilterBarSlice';
import { AGENT, RANGE_DATE } from '../FilterBar/constants/filtersConstants';
import { buildDefaultDateRange } from '../FilterBar/constants/rangeDateOptions';
import { selfAgentFilter } from '@/components/FilterBar/utils';
import Trans from '@/components/shared/Trans';
import filterBarTranslations from '@/components/FilterBar/FilterBar.trans.json';
import { setInitialEditionData } from '@/store/slices/components/dashboard/DashboardSlice';

function Dashboard() {
  const dispatch = useDispatch();
  const { tabActive } = useSelector((state) => state.DashboardSlice);
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { data: userData } = useSelector((state) => state.UserSlice);
  const { dashboardConfig } = useSelector(
    (state) => state.UserPreferencesSlice
  );
  const [currentAgentLoaded, setCurrentAgentLoaded] = useState(false);

  useEffect(() => {
    const self = selfAgentFilter(userData);
    if (!self) return;
    dispatch(
      setSelectedIds({
        idList: [self],
        type: AGENT,
        ephemeral: true,
      })
    );
    setCurrentAgentLoaded(true);
  }, [dispatch, userData?.id]);

  useEffect(() => {
    const tabsWithDate = [DASHBOARD_TABS.PERFORMANCE];
    const isDateTab = tabsWithDate.includes(tabActive);
    const dateTag = selectedIds.find((tag) => tag.filter_type === RANGE_DATE);

    if (isDateTab && !dateTag) {
      const initialDate = [
        {
          ...buildDefaultDateRange((key) => Trans(filterBarTranslations, key)),
          dontRemove: true,
        },
      ];

      dispatch(setSelectedIds({ idList: initialDate, type: RANGE_DATE }));
    } else if (!isDateTab && dateTag) {
      dispatch(removeTag(dateTag));
    }
  }, [tabActive]);

  useEffect(() => {
    dispatch(setInitialEditionData(dashboardConfig));
  }, []);

  if (!currentAgentLoaded) return null;

  return (
    <Box className={styles.dashboardContainer}>
      <Box className={styles.dashboardHeader}>
        <DashboardHeader />
      </Box>
      <Box className={styles.stickyBar}>
        <DashboardTabs />
        <DashboardFilters />
      </Box>
      <Box className={styles.dashboardContent}>
        {tabActive === DASHBOARD_TABS.TODO && <PendingContent />}
        {tabActive === DASHBOARD_TABS.OVERVIEW && <OverviewContent />}
        {tabActive === DASHBOARD_TABS.PERFORMANCE && <PerformanceContent />}
      </Box>
    </Box>
  );
}

export default Dashboard;
